import * as React from 'react';

const Money24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.5 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M21 5H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2M6.724 6.5h10.552a4.75 4.75 0 0 0 4.224 4.224v2.552a4.75 4.75 0 0 0-4.224 4.224H6.724A4.75 4.75 0 0 0 2.5 13.276v-2.552A4.75 4.75 0 0 0 6.724 6.5M2.5 14.788A3.25 3.25 0 0 1 5.212 17.5H3a.5.5 0 0 1-.5-.5zM18.788 17.5a3.25 3.25 0 0 1 2.712-2.712V17a.5.5 0 0 1-.5.5zM5.212 6.5A3.25 3.25 0 0 1 2.5 9.212V7a.5.5 0 0 1 .5-.5zM21.5 9.212A3.25 3.25 0 0 1 18.788 6.5H21a.5.5 0 0 1 .5.5z"
  }
));
Money24.Size = 24;
Money24.Title = "Money";

export { Money24 as default };
